import { PayloadAction } from '@reduxjs/toolkit';
import { ActionTypes } from './loginConfig';
import { LoginState } from './loginInterface';

const initialState: LoginState = {
    error: undefined
};
const reducer = (state: LoginState, action: PayloadAction<any>): LoginState => {
    const { type, payload } = action;
    switch (type) {
        case ActionTypes.UPDATE_USER_IN_CONTEXT:
            return {
                ...state,
                user: payload
            };
        case ActionTypes.UPDATE_LOGIN_ERROR:
            return {
                ...state,
                error: payload
            };
        default:
            return { ...initialState, ...state };
    }
};

export default reducer;
